import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "src/context";
import type { UserDataProps } from "src/types";

const trimSlashes = (str: string) => str.replace(/^\/*|\/*$/g, "");
const buildPath = (...arr: string[]) =>
  "/" +
  arr
    .map((str) => trimSlashes(str))
    .filter((val) => val.length > 0)
    .join("/");
export const buildPagePrefixForUserData = (userData: UserDataProps) => {
  const { dealerName } = useParams();
  const { application_id, borrower_id } = userData || {};
  let loginPathPrefixPieces: string[] = [];
  if (application_id && borrower_id) {
    loginPathPrefixPieces = [
      dealerName ?? "",
      "application",
      application_id,
      "borrower",
      borrower_id,
    ];
  }
  return buildPath(...loginPathPrefixPieces);
};

type UseResponseRedirectFunc = (
  path: string,
  observedResponse: Record<string, unknown> | null,
) => () => void;

// We'll probably eventually want a version of this that optionally takes a 'validator function
// as a third argument. That way you can set what you think is a valid response worth redirecting on
export const useResponseRedirect: UseResponseRedirectFunc = (
  path,
  observedResponse,
) => {
  const { userData } = useContext(UserContext);
  const navigate = useNavigate();
  const pathPrefix = buildPagePrefixForUserData(userData ?? {});
  const fullPath = buildPath(pathPrefix, path);

  // Capture so it can be an observable or called directly
  const navigateFunc = () => navigate(fullPath);

  useEffect(() => {
    if (observedResponse) {
      navigateFunc();
    }
  }, [observedResponse]);

  return navigateFunc;
};

type UseRedirectToPageFunc = (path: string) => () => void;
export const useRedirectToPage: UseRedirectToPageFunc = (path) =>
  useResponseRedirect(path, null);
